$(document).ready(function() {
  $('.flip-items').slick({
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '80px',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: '40px'
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '0px'
        }
      }
    ]
  });
  
  /* Testimonial Slider */
  $('.slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false
  });
});

document.addEventListener('DOMContentLoaded', function () {
    
});

function calculateMinDate(input, pincodeCheckArray, data_checker) {
    const today = new Date();
    let minDate = new Date(today); // Start from today
    let daysAdded = 0;

    // Loop to add days, skipping Sundays and holidays
    while (daysAdded < data_checker) {
        minDate.setDate(minDate.getDate() + 1); 

        const formattedDate = minDate.toISOString().split('T')[0]; // Format the date as "YYYY-MM-DD"
        
        // Skip if the date is Sunday or in the pincodeCheckArray (holidays)
        if (minDate.getDay() !== 0 && !pincodeCheckArray.includes(formattedDate)) {
            daysAdded++;
        }
    }

    disableDates(input, pincodeCheckArray, minDate);
}

function disableDates(input, pincodeCheckArray, minDate) {
    const today = new Date();

    // Create an array of all Sundays in the current year
    let date = new Date(today);
    let disabledDates = [];
    while (date.getFullYear() === today.getFullYear()) {
        if (date.getDay() === 0) { // Sunday
            disabledDates.push(date.toISOString().split('T')[0]);
        }
        date.setDate(date.getDate() + 1);
    }

    // Combine Sundays and `pincodeCheckArray`
    const allDisabledDates = [...new Set([...disabledDates, ...pincodeCheckArray])];

    flatpickr(input, {
        dateFormat: "Y-m-d", // Format for date
        disable: allDisabledDates, // Disable these dates
        minDate: minDate.toISOString().split('T')[0], // Set the calculated minimum selectable date
    });
}


// pincode_checker
$(document).ready(function () {
  if (localStorage.getItem('userPincode')) {
    $('.popup-pincode').hide();
  } else {
    $('.popup-pincode').show();
  }

  $('.pin-validate-btn').click(function () {
    var enteredPincode = $('.pincode-1').val();
    localStorage.removeItem('userPincode');
    localStorage.removeItem('userDateVar');
    localStorage.removeItem('userdelhivery');

    var currentTime = new Date();
    var currentHours = currentTime.getHours();
    var isMatch = false;

    $('.pincodes').each(function () {
      var pincodes = $(this).attr('pincodes').split(',');
      var datevar = parseInt($(this).attr('datevar'));
      if (currentHours >= 17) {
        datevar += 1;
      }
      var delhivery = $(this).attr('delevery_text');
      if (pincodes.includes(enteredPincode)) {
        localStorage.setItem('userPincode', enteredPincode);
        localStorage.setItem('userDateVar', datevar);
        localStorage.setItem('userdelhivery', delhivery);
        isMatch = true;
      }
    });

    $('.popup-pincode').hide();
    $('.pincode-1').val(enteredPincode);
    $('.custom_pincode').addClass('active').text('Pincode ' + enteredPincode);

    if (isMatch) {
      $('.cstm-msg').text(localStorage.getItem('userdelhivery')).css('color', 'black');
      $('.product-page-info__button-add-to-cart').show();
      $('.customaddtocartbutton').hide();
    } else {
      localStorage.setItem('userPincode', enteredPincode);
      localStorage.setItem('userDateVar', 8);
      localStorage.setItem('userdelhivery', 'Delivery time might be longer');

      $('.cstm-msg').text('Delivery time might be longer').css('color', 'red');
      $('.product-page-info__button-add-to-cart').hide();
      $('.customaddtocartbutton').show();
    }
  });

  $('.pincode-1').on('keyup', function () {
    this.value = this.value.replace(/\D/g, '');
  });

  $('.product-page-info__button-add-to-cart').click(function () {
    var date_checker = $('#rental').val();
    var pickup_date = $('#pickup').val();
    $('input[name="properties[Rental Date]"]').val(date_checker);
    $('input[name="properties[Pick Up Date]"]').val(pickup_date);
  });

  $('.close_button').click(function () {
    $('.popup-pincode').hide();
  });

  $('body').on('click', '.custom_pincode', function () {
    $('.popup-pincode').show();
    var pincode_check = localStorage.getItem('userPincode');
    $('.pincode-1').val(pincode_check);
    if (pincode_check) {
      $('.pin-validate-btn span').text('Change');
    }
  });

  // Initial UI load from localStorage
  var pincode_check = localStorage.getItem('userPincode');
  var delivery_text = localStorage.getItem('userdelhivery');
  if (pincode_check) {
    $('.custom_pincode').addClass('active').text('Pincode ' + pincode_check);
    $('.pincode-1').val(pincode_check);

    if (delivery_text === 'Pincode is not serviceable') {
      $('.cstm-msg').css('color', 'red').text(delivery_text);
      $('.product-page-info__button-add-to-cart').hide();
      $('.customaddtocartbutton').show();
    } else {
      $('.cstm-msg').text(delivery_text);
      $('.product-page-info__button-add-to-cart').show();
      $('.customaddtocartbutton').hide();
    }
  } else {
    $('.product-page-info__button-add-to-cart').hide();
    $('.customaddtocartbutton').show();
  }

  // Date setup
  const input = document.getElementById('rental');
  const pincodeCheckString = document.getElementById('national_holiday').textContent.trim();
  const pincodeCheckArray = pincodeCheckString.split(',').map(date => date.trim());
  const data_checker = localStorage.getItem('userDateVar');

  calculateMinDate(input, pincodeCheckArray, data_checker);

  function calculateMinDate(input, pincodeCheckArray, data_checker) {
    const today = new Date();
    let minDate = new Date(today);
    let daysAdded = 0;

    let dateCount = parseInt(data_checker);
    if (isNaN(dateCount)) {
      dateCount = 2;
    }

    while (daysAdded < dateCount) {
      minDate.setDate(minDate.getDate() + 1);
      const formattedDate = minDate.toISOString().split('T')[0];
      if (minDate.getDay() !== 0 && !pincodeCheckArray.includes(formattedDate)) {
        daysAdded++;
      }
    }

    disableDates(input, pincodeCheckArray, minDate);
  }

  function disableDates(input, pincodeCheckArray, minDate) {
    const today = new Date();
    let date = new Date(today);
    let disabledDates = [];

    while (date.getFullYear() === today.getFullYear()) {
      if (date.getDay() === 0) {
        disabledDates.push(date.toISOString().split('T')[0]);
      }
      date.setDate(date.getDate() + 1);
    }

    const allDisabledDates = [...new Set([...disabledDates, ...pincodeCheckArray])];

    flatpickr(input, {
      dateFormat: 'Y-m-d',
      disable: allDisabledDates,
      minDate: minDate.toISOString().split('T')[0],
    });
  }

  $('.customaddtocartbutton').click(function () {
    $('.cstm-msg').text('Please check the pincode first.').css({ color: 'red' });
    $('.popup-pincode').show();
  });
});


